export const RECEIVE_FLOOR = 'RECEIVE_FLOOR';
